module.exports = __webpack_public_path__ + "img/line.64759c4a.svg";